import React from 'react';
import './css/cookiesMessage.css';
import DismissableMessage from './dismissableMessage';

const cookieMessage = () => {
	return (
		<div className="cookie-message">
			<DismissableMessage messageKey='cookieMessage' type="info" dismissButtonLabel="Ok, Got it">
				Our dashboard uses a persistent first-party cookie to keep you logged in. By using our service and proceeding to log in you agree to our use of the cookie technology.
			</DismissableMessage>
		</div>	
	);
};

export default cookieMessage;